import { AppRedirect } from "./AppRedirect";

export default AppRedirect;
